import React from 'react';
import styled from 'styled-components';
import { LongBody } from 'components/Typography';

export const SizedLongBody = styled(({ reverse, ...otherProps }) => (
  <LongBody {...otherProps} />
))`
  && {
    margin-bottom: 0px;
    margin-left: ${(props) => (props.reverse ? '300px' : '0px')};
  }
`;
